// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header-module__header____UEA_ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 108px;
  padding: 16px 40px;
  background-color: #ffffff;
  border-bottom: 1px solid #d9dbe9;
  box-shadow: 0px 2px 4px 0px #0000001a;
}

.Header-module__logo___KYK77 {
  width: 165px;
  height: 101px;
  opacity: 1;
  cursor: pointer;
}

.Header-module__controls___yX7Ui {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.Header-module__location___uvI4r {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #4a5568;
}

.Header-module__location___uvI4r > span {
  font-family: Montserrat;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 8%;
  text-transform: uppercase;
}

.Header-module__userProfile___GvZN5 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.Header-module__chevronDown___SXgUk {
  width: 24px;
  height: 24px;
  color: #4a5568;
  transition: transform 0.3s ease;
}

.Header-module__rotate___rLs_r {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.Header-module__notifications___qxs0n {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  background-color: #d8edfe;
  opacity: 1;
}

.Header-module__notifications___qxs0n > img {
  width: 18px;
  height: 18px;
}

.Header-module__icon___LIzBH {
  color: #4a5568;
}

.Header-module__userMenu___lpshU {
  position: relative;
}

.Header-module__userProfile___GvZN5 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.Header-module__logout___b56gt {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 164px;
  height: auto;
  background: white;
  border-radius: 12px;
  padding: 6px 12px;
  border: 1px solid #d9dbe9;
  box-shadow: 0px -3px 6px 0px #4a4a4a1a;
  cursor: pointer;
  z-index: 10;
  font-family: Montserrat;
  font-weight: 500;
  font-size: 14px;
  line-height: 200%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
  color: #4e4b66;
}

.Header-module__logout___b56gt:hover {
  background-color: #d8edfe;
}

.Header-module__logout___b56gt img {
  width: 20px;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/header/Header.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 108px;\n  padding: 16px 40px;\n  background-color: #ffffff;\n  border-bottom: 1px solid #d9dbe9;\n  box-shadow: 0px 2px 4px 0px #0000001a;\n}\n\n.logo {\n  width: 165px;\n  height: 101px;\n  opacity: 1;\n  cursor: pointer;\n}\n\n.controls {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.location {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: #4a5568;\n}\n\n.location > span {\n  font-family: Montserrat;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 100%;\n  letter-spacing: 8%;\n  text-transform: uppercase;\n}\n\n.userProfile {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n}\n\n.chevronDown {\n  width: 24px;\n  height: 24px;\n  color: #4a5568;\n  transition: transform 0.3s ease;\n}\n\n.rotate {\n  transform: rotate(180deg);\n  transition: transform 0.3s ease;\n}\n\n.notifications {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  background-color: #d8edfe;\n  opacity: 1;\n}\n\n.notifications > img {\n  width: 18px;\n  height: 18px;\n}\n\n.icon {\n  color: #4a5568;\n}\n\n.userMenu {\n  position: relative;\n}\n\n.userProfile {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n}\n\n.logout {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  width: 164px;\n  height: auto;\n  background: white;\n  border-radius: 12px;\n  padding: 6px 12px;\n  border: 1px solid #d9dbe9;\n  box-shadow: 0px -3px 6px 0px #4a4a4a1a;\n  cursor: pointer;\n  z-index: 10;\n  font-family: Montserrat;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 200%;\n  letter-spacing: 0%;\n  vertical-align: middle;\n  text-transform: capitalize;\n  color: #4e4b66;\n}\n\n.logout:hover {\n  background-color: #d8edfe;\n}\n\n.logout img {\n  width: 20px;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header-module__header____UEA_`,
	"logo": `Header-module__logo___KYK77`,
	"controls": `Header-module__controls___yX7Ui`,
	"location": `Header-module__location___uvI4r`,
	"userProfile": `Header-module__userProfile___GvZN5`,
	"chevronDown": `Header-module__chevronDown___SXgUk`,
	"rotate": `Header-module__rotate___rLs_r`,
	"notifications": `Header-module__notifications___qxs0n`,
	"icon": `Header-module__icon___LIzBH`,
	"userMenu": `Header-module__userMenu___lpshU`,
	"logout": `Header-module__logout___b56gt`
};
export default ___CSS_LOADER_EXPORT___;
